// import axios from 'axios';
import logger from '../logger';
import api from './auth'


export const fetchSources = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/map/source/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching sources:', error);
    throw error;
  }
};

export const fetchLayers = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/map/layer/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching layers:', error);
    throw error;
  }
};

export const fetchFeatures = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/map/feature/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching features:', error);
    throw error;
  }
};

export const fetchDataUnits = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/data/units/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching features:', error);
    throw error;
  }
};

export const fetchSourceParameters = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/map/source/parameters/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching projections and types:', error);
    throw error;
  }
};

export const fetchLanguages = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/data/languages/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching languages:', error);
    throw error;
  }
};

export const fetchSensorsById = async (objectId) => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/sensors/linked-to/${objectId}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching sensors:', error);
    // throw error;
  }
};

// export const fetchSensorParameters = async () => {
//   try {
//     const response = await api.get(`${process.env.REACT_APP_DB_URL}/sensors/parameters/`);
//     return response.data;
//   } catch (error) {
//     logger.error('Error fetching sensor parameters:', error);
//     throw error;
//   }
// };

export const fetchSensorData = async (sensorId) => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/sensors/sensor-data/by-sensor-id/${sensorId}`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching sensor data:', error);
    // throw error;
  }
};

export const fetchDataStates = async () => {
  try {
    const response = await api.get(`${process.env.REACT_APP_DB_URL}/data/states/`);
    return response.data;
  } catch (error) {
    logger.error('Error fetching data states:', error);
    throw error;
  }
};

export const sendCoordinates = async (coordinates) => {
  try {
    const response = await api.post(`${process.env.REACT_APP_DB_URL}/map/update-position/`, coordinates);
    return response.data;
  } catch (error) {
    logger.error('Error sending coordinates:', error);
    throw error;
  }
};

export const updateLayers = async (layerId, data) => {
  try {
    const response = await api.patch(`${process.env.REACT_APP_DB_URL}/map/layer/${layerId}/`, data);
    return response.data;
  } catch (error) {
    logger.error('Error fetching sensor data:', error);
    // throw error;
  }
};